import React, { Component } from 'react';
import { Button, Input } from 'semantic-ui-react';
import $ from "jquery";
import server from '../../functions/server';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogActions, DialogContent, DialogTitle, DialogContentText } from '@material-ui/core';



class OrderTracking extends Component {

  state = {
    dialog: false, 
    loading: false,
    orderTracking: {
      vehicle_no: "",
      mobile_no: "",
      name: "", 
      type: "WheelsEye", 
      external_tracking_id: "",
      order_id: this.props.orderId, 
      shop_id: this.props.shopId
    }
  }

  onChangeText = (value, type) => {
    let orderTracking = this.state.orderTracking;
    orderTracking[type] = value;
    this.setState({ orderTracking });
  }

  submit = () => {  
    let context = this;
    let orderTracking = this.state.orderTracking;
    this.setState({ loading: true });
    $.ajax({
      type: 'POST',
      data: { data: JSON.stringify(orderTracking) },
      url: server() + '/ordertracking/create.php',
      success: function(data) {
        if (data == 1) {
          alert(`Order tracking details saved successfully`);
          context.setState({ loading: false, dialog: false });
        }
        else {
          alert("Failed to save order tracking details");
          context.setState({ loading: false } );
        }
      },
      error: function(err) {
        alert("Failed to save order tracking details");
        context.setState({ loading: false } );
      }
    });
    
  }

  getOrderTrackingDetails = () => {
    let context = this;
    context.setState({ loading: true });
    $.ajax({
      type: 'POST',
      data: { order_id: this.props.orderId },
      url: server() + '/ordertracking/get.php',
      success: function(orders) {
        console.log(orders);
        orders = JSON.parse(orders);
        context.setState({ 
          loading: false,
          dialog: true,
          orderTracking: orders.length > 0 ? orders[0] : context.state.orderTracking
        });
      },
      error: function(err) {
        context.setState({ loading: false });
      }
    });
  }

  render() {
    return (
      <div>
        <Buttons onClick={() => this.getOrderTrackingDetails()} style={{ color: "blue" }}>Order Tracking</Buttons>
        <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={this.state.dialog}
        onClose={() => this.setState({ dialog: false })}
      >
        <DialogTitle>Order Tracking</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <b>Vehicle Number</b><br/>
            <Input value={this.state.orderTracking.vehicle_no} fluid placeholder="Vehicle Number" onChange={(e) => this.onChangeText(e.target.value, "vehicle_no")} />
            <br/><b>Mobile</b><br/>
            <Input value={this.state.orderTracking.mobile_no} fluid placeholder="Mobile" onChange={(e) => this.onChangeText(e.target.value, "mobile_no")} />
            <br/><b>Driver Name</b><br/>
            <Input value={this.state.orderTracking.name} fluid placeholder="Driver Name" onChange={(e) => this.onChangeText(e.target.value, "name")} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ dialog: false })}>Close</Button>
          <Button loading={this.state.loading} onClick={() => this.submit()}>Submit</Button>
        </DialogActions>
      </Dialog>
      </div>
    );
  }
}

export default OrderTracking;
